/**
 * Hook para obtener detalles de una reserva por su ID
 * Usado en ReservationConfirmationPage después del pago
 */
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/services/apiClient'

export interface Reserva {
  id: string
  espacio_id: string
  espacio_nombre: string
  espacio_codigo: string
  fecha_entrada: string
  fecha_salida: string
  cantidad_huespedes: number
  estado: string
  estado_pago: string
  monto_total: number
  solicitudes_especiales?: string
  fecha_creacion: string
  huesped_nombre: string
  huesped_email: string
  huesped_telefono: string
  huesped_documento: string
  unidad_reserva?: string  // 'dia' o 'noche'
}

interface ReservasResponse {
  reservas: Reserva[]
  total: number
}

export const useReservations = (email?: string, numero_documento?: string, reserva_id?: string) => {
  return useQuery<ReservasResponse>({
    queryKey: ['reservas', email, numero_documento, reserva_id],
    queryFn: async () => {
      if (!email && !numero_documento && !reserva_id) {
        throw new Error('Email, número de documento o ID de reserva requerido')
      }

      const params = new URLSearchParams()
      if (email) params.append('email', email)
      if (numero_documento) params.append('numero_documento', numero_documento)
      if (reserva_id) params.append('reserva_id', reserva_id)

      const response = await apiClient.get(
        `/api/espacios/reservas?${params.toString()}`
      )
      return response.data
    },
    enabled: !!(email || numero_documento || reserva_id),
  })
}
